interface Props {
  logo: string;
}

const LoginLogo = ({ logo }: Props) => {
  return (
    <div className="flex justify-center mb-8">
      <img src={logo} alt="Logo" className="h-12 object-contain" />
    </div>
  );
};

export default LoginLogo;
